class VendorForm {
  constructor() {
    this.form = document.getElementById('vendorForm');
    this.submitButton = document.getElementById('submitButton');
    this.submitSpinner = document.getElementById('submitSpinner');
    
    this.maxFileSize = 10 * 1024 * 1024; // 10MB en bytes
    this.initializeForm();
  }

  initializeForm() {
    if (this.form) {
      this.form.addEventListener('submit', this.handleSubmit.bind(this));
    }
  }

  async handleSubmit(e) {
    e.preventDefault();
    
    if (!this.validateForm()) {
      return;
    }

    if (!this.validateFileSize()) {
      return;
    }

    this.setLoadingState(true);
    
    try {
      const formData = new FormData(this.form);
      const response = await fetch(this.form.action, {
        method: 'POST',
        body: formData,
        headers: {
          'Accept': 'application/json'
        }
      });
      
      if (response.ok) {
        const redirectUrl = formData.get('_next') || '/';
        window.location.href = redirectUrl;
      } else {
        const errorData = await response.json().catch(() => ({}));
        throw new Error(errorData.error || 'Form submission failed');
      }
    } catch (error) {
      console.error('Error:', error);
      alert('There was an error submitting the form. Please try again.');
      this.setLoadingState(false);
    }
  }

  validateFileSize() {
    const files = {
      tobacco_license: document.getElementById('tobacco_license').files[0],
      vendor_permit: document.getElementById('vendor_permit').files[0]
    };

    for (const [fieldName, file] of Object.entries(files)) {
      if (file && file.size > this.maxFileSize) {
        alert(`${fieldName.replace('_', ' ').toUpperCase()} file is too large. Maximum size is 10MB.`);
        return false;
      }
    }

    return true;
  }

  validateForm() {
    let isValid = true;
    this.clearErrorMessages();

    // Validar campos requeridos
    const requiredFields = this.form.querySelectorAll('[required]');
    requiredFields.forEach(field => {
      if (!field.value) {
        isValid = false;
        this.showError(field, 'This field is required');
      }
    });

    // Validar email
    const emailField = this.form.querySelector('#email');
    if (emailField.value && !this.isValidEmail(emailField.value)) {
      isValid = false;
      this.showError(emailField, 'Please enter a valid email address');
    }

    return isValid;
  }

  setLoadingState(loading) {
    this.submitButton.disabled = loading;
    this.submitButton.textContent = loading ? 'Submitting...' : 'Submit Application';
    this.submitSpinner.style.display = loading ? 'block' : 'none';
  }

  clearErrorMessages() {
    const errorMessages = this.form.querySelectorAll('.error-message');
    errorMessages.forEach(msg => msg.remove());
  }

  showError(field, message) {
    const errorMsg = document.createElement('div');
    errorMsg.className = 'error-message';
    errorMsg.textContent = message;
    field.parentNode.appendChild(errorMsg);
  }

  isValidEmail(email) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  }
}

// Inicializar el formulario cuando el DOM esté listo
document.addEventListener('DOMContentLoaded', () => {
  new VendorForm();
});